import React, { FC, ReactNode } from 'react'

import * as SC from './styled'

export type FormLabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
  className?: string
  required?: boolean
  error?: boolean
  children?: ReactNode
  variant?: 'default' | 'black' | string
}

const FormLabel: FC<FormLabelProps> = ({ error, children, variant = 'default', ...props }) => {
  return (
    <SC.Label {...props} $error={error} $variant={variant}>
      {children}
    </SC.Label>
  )
}

export default FormLabel
